// src/utils/getVoucherLink.js

export const getVoucherLink = (voucher) => {
  if (voucher.parentUid) {
    const baseLink = `${window.location.origin}/dashboard/vouchers/${voucher.parentUid}/${voucher.id}`
    return baseLink
  }
  return `${window.location.origin}/dashboard/vouchers/${voucher.id}`
}
